// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, NineSlicePlane, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '',
      data: {
        tab: {
          active: {
            texture: 'Tournament_Active_Top_Tab',
            y: 0,
          },
          inactive: {
            texture: 'Tournament_Inactive_Top_Tab',
            y: 20,
          },
        },
        label: {
          active: {
            fill: 'white',
            y: 60,
          },
          inactive: {
            fill: '#fcc795',
            y: 54,
          },
        },
        icon: {
          active: {
            y: 63,
          },
          inactive: {
            y: 57,
          },
        },
        icons: {
          global: {
            active: 'Tournament_Active_Global_Icon',
            inactive: 'Tournament_Inactive_Global_Icon',
          },
          friends: {
            active: 'Tournament_Active_Friends_Icon',
            inactive: 'Tournament_Inactive_Friends_Icon',
          },
          you: {
            active: 'Tournament_Active_You_Icon',
            inactive: 'Tournament_Inactive_You_Icon',
          },
        },
      },
    },
    {
      id: 'a4424353-48a8-4dad-96db-7f2d0839a9a1',
      type: 'Sprite',
      name: 'backgroundLandscape',
      className: '',
      x: 0,
      y: 161,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'bg',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '14322794-5b07-4497-89c4-9e2c336f54ce',
      type: 'Container',
      name: 'contentWrapper',
      className: '',
      x: 0,
      y: 180,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '2799c08e-15e3-4e24-b219-d57b0a332007',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Top_Dark_Part',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '25a98dfb-3990-4992-a7d5-f61cd74c0599',
      type: 'Container',
      name: 'topBarContainer',
      className: '',
      x: 0,
      y: 64,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '99398bd7-0a0f-420d-9f4e-febf4a0aeeb6',
      type: 'Container',
      name: 'spinnerSlot',
      className: '',
      x: 0,
      y: 600,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '483b0a5d-4ff8-429a-b295-80e556a6568a',
      type: 'Sprite',
      name: 'scrollInput',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -1000,
        y: 0,
        width: 2000,
        height: 3000,
      },
      texture: '',
      parent: '14322794-5b07-4497-89c4-9e2c336f54ce',
    },
    {
      id: '5ae065b4-1992-4085-9147-4514470ce829',
      type: 'Container',
      name: 'leaderboardsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '14322794-5b07-4497-89c4-9e2c336f54ce',
    },
    {
      id: '877232d0-03a1-424c-b7fe-d3d07dc1c5ae',
      type: 'NineSlicePlane',
      name: 'bar',
      className: '',
      x: -390,
      y: 88,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      width: 780,
      height: 58,
      leftWidth: 10,
      topHeight: 0,
      rightWidth: 10,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Top_Bar_Fragment',
      parent: '25a98dfb-3990-4992-a7d5-f61cd74c0599',
    },
    {
      id: '79141089-7279-4c8c-886d-e608910aa4b5',
      type: 'Container',
      name: 'globalTab',
      className: '',
      x: -250,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -120,
        y: 0,
        width: 240,
        height: 110,
      },
      parent: '25a98dfb-3990-4992-a7d5-f61cd74c0599',
      data: {
        tapSound: 'UI_Button_Click',
      },
    },
    {
      id: '6aaf890f-75a8-4790-b04f-337160593ade',
      type: 'Container',
      name: 'friendsTab',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -120,
        y: 0,
        width: 240,
        height: 110,
      },
      parent: '25a98dfb-3990-4992-a7d5-f61cd74c0599',
      data: {
        tapSound: 'UI_Button_Click',
      },
    },
    {
      id: '4cccc947-d292-4808-8e5d-59dfc98dd1a8',
      type: 'Container',
      name: 'youTab',
      className: '',
      x: 250,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -120,
        y: 0,
        width: 240,
        height: 110,
      },
      parent: '25a98dfb-3990-4992-a7d5-f61cd74c0599',
      data: {
        tapSound: 'UI_Button_Click',
      },
    },
    {
      id: 'f52986ee-b76f-4ab0-9adf-4c15e2a40aea',
      type: 'Container',
      name: 'globalContent',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '5ae065b4-1992-4085-9147-4514470ce829',
    },
    {
      id: 'caea80c4-45b1-40ea-b1b4-ef35bc29290e',
      type: 'Container',
      name: 'friendsContent',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '5ae065b4-1992-4085-9147-4514470ce829',
    },
    {
      id: 'b24ca027-1760-455b-b454-16f1b99d5f5c',
      type: 'Container',
      name: 'youContent',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '5ae065b4-1992-4085-9147-4514470ce829',
    },
    {
      id: 'c9dc50e1-a161-4086-8372-149386e2df47',
      type: 'Sprite',
      name: 'globalTabBackground',
      className: 'tabSprite',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Active_Top_Tab',
      parent: '79141089-7279-4c8c-886d-e608910aa4b5',
    },
    {
      id: '0ba8aa9d-13db-4e3b-86fa-85fd857e3de4',
      type: 'Sprite',
      name: 'globalIcon',
      className: 'tabIcon',
      x: -58,
      y: 63,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Active_Global_Icon',
      parent: '79141089-7279-4c8c-886d-e608910aa4b5',
    },
    {
      id: '96cce5b6-00d1-45d1-bbd0-49f969149dc7',
      type: 'Text',
      name: 'globalLabel',
      className: 'tabLabel',
      x: 41,
      y: 60,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Global',
      localize: true,
      maxWidth: 150,
      maxHeight: 53,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#300002',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '79141089-7279-4c8c-886d-e608910aa4b5',
    },
    {
      id: '0bcec8b0-77e4-404d-97d9-c0022b185294',
      type: 'Sprite',
      name: 'friendsTabBackground',
      className: 'tabSprite',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Inactive_Top_Tab',
      parent: '6aaf890f-75a8-4790-b04f-337160593ade',
    },
    {
      id: '5bec9d2a-9996-4ba3-999c-45097abf0b2c',
      type: 'Sprite',
      name: 'friendsIcon',
      className: 'tabSprite',
      x: -45,
      y: 57,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Inactive_Friends_Icon',
      parent: '6aaf890f-75a8-4790-b04f-337160593ade',
    },
    {
      id: '9141b607-ed96-4518-a3b1-c464863ae17c',
      type: 'Text',
      name: 'friendsLabel',
      className: 'tabLabel',
      x: 41,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Friends',
      localize: true,
      maxWidth: 150,
      maxHeight: 53,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fcc795',
        stroke: '#300002',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '6aaf890f-75a8-4790-b04f-337160593ade',
    },
    {
      id: '57af426b-0410-4d7b-91b0-837f3cc1fc9f',
      type: 'Sprite',
      name: 'youTabBackground',
      className: 'tabSprite',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Inactive_Top_Tab',
      parent: '4cccc947-d292-4808-8e5d-59dfc98dd1a8',
    },
    {
      id: '0f20a12e-dc6b-4fc3-bfd0-a559c6838cca',
      type: 'Sprite',
      name: 'youIcon',
      className: 'tabSprite',
      x: -45,
      y: 57,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Inactive_You_Icon',
      parent: '4cccc947-d292-4808-8e5d-59dfc98dd1a8',
    },
    {
      id: '8105c189-ee2d-4319-980f-ae40f8e84968',
      type: 'Text',
      name: 'youLabel',
      className: 'tabLabel',
      x: 41,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'You',
      localize: true,
      maxWidth: 150,
      maxHeight: 53,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fcc795',
        stroke: '#300002',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '4cccc947-d292-4808-8e5d-59dfc98dd1a8',
    },
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  handleResize: false,
} as const;

export class TournamentPageLayout {
  static raw = raw;
  root!: Container & { data: (typeof raw)['list'][0]['data'] };
  backgroundLandscape!: Sprite;
  contentWrapper!: Container;
  background!: Sprite;
  topBarContainer!: Container;
  spinnerSlot!: Container;
  scrollInput!: Sprite;
  leaderboardsContainer!: Container;
  bar!: NineSlicePlane;
  globalTab!: Container & { data: (typeof raw)['list'][9]['data'] };
  friendsTab!: Container & { data: (typeof raw)['list'][10]['data'] };
  youTab!: Container & { data: (typeof raw)['list'][11]['data'] };
  globalContent!: Container;
  friendsContent!: Container;
  youContent!: Container;
  globalTabBackground!: Sprite;
  globalIcon!: Sprite;
  globalLabel!: Text;
  friendsTabBackground!: Sprite;
  friendsIcon!: Sprite;
  friendsLabel!: Text;
  youTabBackground!: Sprite;
  youIcon!: Sprite;
  youLabel!: Text;
  tabSprite!: Sprite[];
  tabIcon!: Sprite[];
  tabLabel!: Text[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
